import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

function HeadlineOne(props: Props) {
  const { className, children } = props
  return <h1 className={classNames(style.wrapper, className)}>{children}</h1>
}

export default HeadlineOne
